// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function RevvGridHeader(props) {
  const { col } = props;
  return (
    <div
      className="rs-header-cell"
      col-draggable={col.draggable}
      col-id={col.field}
      col-name={col.name}
      col-min-width={col.minWidth}
      col-type="pinned"
      role="presentation"
      style={{ minWidth: col.minWidth, width: col.width }}
      unselectable="on">
      <span
        className="rs-sort"
        onKeyPress={() => null}
        role="button"
        tabIndex="0"
        onClick={() => props.sortData(col)}>
        {col.headerName}
      </span>
      {col.sortStatus && <FontAwesomeIcon icon={["fas", col.sortStatus]} />}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/Components/RG_Header.js